import { Box, Button, Card, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import { Grid } from "@mui/material";
import { Link } from 'react-router-dom';
import { getDAPickupToday } from "../../services/pickup";
import QuickTrackingDA from "../QuickTrackingDA";
import { D2DOrderAssignedToDA } from "../../services/vendors";

const TodayVendorRequests = () => {

  const [today,setToday]=useState([])

  useEffect(()=>{
    const getTodayDelivery=async()=>{
      const {data}= await D2DOrderAssignedToDA(window.localStorage.getItem('username')
      );
      if(data){
        console.log('data: ', data);
        setToday(data)  
      }
    }
    getTodayDelivery()
  },[])

  return (
    <>
      {/* <AppBarDA/> */}
      <QuickTrackingDA />
      <div style={{ padding: "10px" }}>
        <Card sx={{ padding: "10px" }}>
          <Typography variant="heading6" fontWeight={600} mb={1}>
            D2D Orders
          </Typography>
          {today.map((item, i) => (
            <React.Fragment key={i}>
              <Link to={item.vendorOrderStatus==="DA Assigned"||item.vendorOrderStatus==="RTV Initiated"||item.vendorOrderStatus==="Picked"?`/rover/DA/packageInformationD2D/${item?.vendorBookingId}`:"#"}>
              <Box
                sx={{
                  marginBottom: "8px",
                  padding: "5px",
                  backgroundColor: "#F4F8FF",
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={1.5}>
                    <div
                      style={{
                        backgroundColor: "#44AD1F",
                        borderRadius: "12px",
                        height: "25px",
                        width: "25px",
                        textAlign:"center",
                        color:"#fff "
                      }}
                    >
                      {i + 1}
                    </div>
                  </Grid>
                  <Grid item xs={6.5}>
                    <div style={{lineHeight:1, color:"#11142D"}}>
                      <Typography variant="body2" fontWeight={600}>{item.customerName}</Typography>
                      <Typography variant="body2" fontWeight={400}>{item.vendorOrderStatus==="DA Assigned"?item.pickupStore:item.deliveryAddress}</Typography>
                    </div>
                  </Grid>
                  <Grid item xs={3.5} sx={{color:"#11142D"}}>
                      <Typography variant="caption" fontSize={10} fontWeight={600}>{item.totalPayableAmount>0?"Cash On Delivery":"Prepaid"}</Typography>
                      <div>
                        <div style={{color:"white", fontSize:10, padding:1,backgroundColor:item.vendorOrderStatus==="Delivered"?"#44AD1F":"#B10000", textAlign:"center",borderRadius:"12px"}}>{"  "+item?.vendorOrderStatus?.toUpperCase()+"  "}</div>
                        </div>

                  </Grid>
                </Grid>
              </Box>
              </Link>
              
            </React.Fragment>
          ))}
        </Card>
      </div>
    </>
  );
};

export default TodayVendorRequests;
